import { Dispatch } from "../types";

export const SAVE_ROUTE = "SAVE_ROUTE";

export const saveRoute = (pathname: string) => (dispatch: Dispatch) => {
  dispatch({ type: SAVE_ROUTE, payload: { data: pathname } });
};
